export const TREEZ_ASSETS_URL = 'https://assets.treez.io/icons';


// WEBPACK FOOTER //
// ./src/const/app_const.js